<template>
  <div class="log">
    <v-btn
      @click.stop="
        open();
        getMilestones();
      "
      :disabled="loading"
      class="milestone-action-btn milestone-action-btn--primary"
    >
      Change Milestone</v-btn
    >

    <v-dialog
      v-model="dialog"
      persistent
      content-class="milestone-dialog"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="cm-card">
          <div class="cm-head">
            <span class="cm-head__icon"><v-icon>alt_route</v-icon></span>
            <div class="cm-head__text">
              <strong>Change Milestone</strong>
              <span>Switch this assignment to a different milestone route.</span>
            </div>
            <v-btn
              icon
              class="cm-head__close"
              @click.prevent="dialog = false"
              @click="closeMain"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-progress-linear
            indeterminate
            color="orange"
            height="3"
            class="cm-progress"
            v-show="loading"
          ></v-progress-linear>

          <div class="cm-body">
            <div class="cm-current">
              <span class="cm-label">Current milestone</span>
              <div class="cm-route">
                <v-icon small>place</v-icon>
                <span>{{ assignmentDetails.milestoneData.pickupLocation }}</span>
                <v-icon small class="cm-route__arrow">arrow_forward</v-icon>
                <span>{{ assignmentDetails.milestoneData.dropOffLocation }}</span>
              </div>
            </div>

            <div
              v-if="this.milestoneTrack.milestone.length == 0"
              class="cm-field"
            >
              <span class="cm-label">New milestone</span>
              <div class="cm-select-row">
                <v-select
                  v-model="milestone"
                  :items="milestoneOptions"
                  :item-text="
                    (item) => `${item.pickupLocation} - ${item.dropOffLocation}`
                  "
                  item-value="_id"
                  label="Select milestone"
                  class="cm-select"
                  @change="getChecklist"
                  hide-details
                  single-line
                >
                  <template slot="item" slot-scope="data"
                    >{{ data.item.pickupLocation }} -
                    {{ data.item.dropOffLocation }}
                    <span v-if="data.item.disabled" class="milestone-current-tag"
                      >Current</span
                    >
                  </template>
                </v-select>
                <v-btn
                  icon
                  class="cm-clear"
                  title="Clear selection"
                  @click="clearMilestone"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </div>

            <div v-if="milestone" class="cm-checklist">
              <span class="cm-label">Checkpoints in this milestone</span>
              <ol class="cm-steps">
                <li v-for="(item, i) in checkList" :key="i">
                  <span class="cm-steps__index">{{ i + 1 }}</span>
                  <span class="cm-steps__name">{{ item.name }}</span>
                </li>
              </ol>
            </div>

            <div v-if="haserror && error" class="cm-error">
              <v-icon small>error_outline</v-icon>
              <span>{{ error }}</span>
            </div>
          </div>

          <div class="cm-actions">
            <v-btn flat class="cm-btn cm-btn--ghost" @click="closeMain()"
              >Cancel</v-btn
            >
            <v-btn
              flat
              class="cm-btn cm-btn--primary"
              @click="submitChangeMilestone()"
              >Submit</v-btn
            >
          </div>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
      v-model="dialogFinalConfirmation"
      persistent
      content-class="milestone-confirm-dialog"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card class="cm-card">
        <div class="cm-head">
          <span class="cm-head__icon"><v-icon>help_outline</v-icon></span>
          <div class="cm-head__text">
            <strong>Final Confirmation</strong>
            <span>Are you sure you want to change the milestone?</span>
          </div>
          <v-btn
            icon
            class="cm-head__close"
            @click="dialogFinalConfirmation = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="cm-actions">
          <v-btn
            flat
            class="cm-btn cm-btn--ghost"
            :disabled="loading"
            @click="close()"
            >No</v-btn
          >
          <v-btn
            flat
            class="cm-btn cm-btn--primary"
            :disabled="loading"
            @click="changeMilestone()"
            >Yes, change</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import {
  TruckPrefix,
  countries,
  TruckTypes,
} from "../../../constants/constants";

import Autocomplete from "vuejs-auto-complete";
import ErrorBox from "@/components/Common/ErrorBox";
import Loading from "vue-loading-overlay";
import CustomerCurrency from "@/components/Common/CustomerCurrency";
import { StorageKeys } from "../../../constants/constants";
import { updateAssignments, milestoneList } from "../../../constants/api-urls";
export default {
  data() {
    return {
      workingCountry: null,
      workingCountries: [],
      checklist: [],
      truckTypes: TruckTypes,

      lazy: false,
      valid: true,
      driverName: "",
      truckNo: "",
      truckType: "",
      driverPrice: "",
      customerPrice: "",
      milestone: null,
      milestoneItems: [],
      currentMilestoneId: "",
      dialogFinalConfirmation: false,
      currentMilestone: 0,
      milestoneTrack: {
        milestone: [],
        assId: null,
      },
      toggle_exclusive: 0,

      assetId: null,
      prefixTrucks: [],

      error: null,
      loading: false,
      options: {
        color: "#ffc04c",
        width: 400,
        zIndex: 200,
      },
      searchText: null,
      driver: {
        id: null,
        name: null,
      },

      AssignmentId: [],
      count: "",

      vendorNames: [],
      vendorName: [],
      VendorNumber: null,
      paymentCurrency: null,

      waybillNo: null,
      pickupTime: null,
      assetId: null,
      options: {
        color: "#ffc04c",
        width: 560,
        zIndex: 200,
      },
      dialogOver: false,
      message: "",
      assets: [],
      currencies: ["AED", "SAR"],
      rules: {
        required: (value) => !!value || "This field is required.",
        noWhiteSpace: (v) =>
          (v != null && v.trim().length > 0) || "Enter valid value.",
        emailRules: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          "E-mail must be valid",
        countryCode: (v) =>
          /^(\+?\d{1,3}|\d{1,4})$/.test(v) ||
          "Please Enter Valid Country Code.",
        phoneNumber: (v) =>
          /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(v) ||
          "Please Enter Valid Mobile No.",
        vatNumber: (v) =>
          /^([a-zA-Z0-9_-]){1,20}$/.test(v) || "Please Enter Valid Vat Number",
      },
      x: {
        error: null,
      },
      items: [],
      processing: false,
      reason: "",
      dialog: false,
      disStatus: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  components: {
    Loading,
    ErrorBox,
    CustomerCurrency,
    Autocomplete,
  },
  props: {
    assignmentDetails: Object,
  },
  computed: {
    milestoneOptions() {
      const current = this.assignmentDetails.milestoneData;
      const currentId = current && current._id;
      return this.milestoneItems.map((item) => ({
        ...item,
        disabled: item._id === currentId,
      }));
    },
  },

  created() {},

  methods: {
    close() {
      this.dialogFinalConfirmation = false;
      // this.milestone = null;
      // this.$emit("refresh-list-Vas");
    },
    closeMain() {
      this.dialog = false;
      this.milestone = null;
      // this.$emit("refresh-list-Vas");
    },

    submitChangeMilestone() {
      if (!this.milestone) {
        this.loading = false;
        this.error = "Please attach milestone ";
        setTimeout(() => {
          this.error = "";
        }, 4000);
        return false;
      }
      if (this.milestone == this.assignmentDetails.milestoneData._id) {
        this.loading = false;
        this.error = "Please choose other milestone , its already selected ";
        setTimeout(() => {
          this.error = "";
        }, 4000);
        return false;
      }
      console.log(this.milestone.length);

      console.log(this.milestone && this.milestone.length > 0);
      this.dialogFinalConfirmation = true;
    },
    open() {
      this.dialog = true;
    },
    getText(arr = [], val) {
      let finalEl = null;

      finalEl = arr.find((el) => el.value === val.toString());

      return finalEl ? finalEl.text : "NA";
    },
    getChecklist() {
      if (this.milestone) {
        this.milestoneItems.filter((x) => {
          if (this.milestone == x._id) {
            this.checkList = x.checkList;
          }
        });
      }
    },
    updateMilestone() {
      if (this.milestone) {
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };

        this.loading = true;
        let url = updateAssignments;
        let body = {
          assId: this.$props.assignNumber.toString() || this.ids,
          milestoneId: this.milestone.toString(),
        };
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            // this.dailog2=false;

            this.loading = false;
          },
          (error) => {
            this.loading = true;
            this.error = error.data.message;
          }
        );
      }
    },
    clearMilestone() {
      this.milestone = null;
      this.getMilestones();
    },
    getMilestones() {
      let url = milestoneList;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      if (localStorage.getItem("workingCountries")) {
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        let workingCountry = [];
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            workingCountry.push(key.value);
          }
        });
        this.workingCountry = JSON.stringify(workingCountry);
      }
      let body = {
        workingCountry: this.workingCountry,
        assignDriver: "true",
      };

      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.milestoneItems = response.data.data;
        },
        (error) => {
          this.error = "Failed to Fetch Milestone Status";
        }
      );
    },

    // close() {
    //   this.vendorName = [];
    //   this.VendorNumber = "";
    //   this.milestone = null;
    //   this.ids = "";
    //   this.paymentAmount = "";
    //   this.vendorVatNumber = "";
    //   this.VendorAddress = "";
    //   this.countryCode = "";
    //   // this.truckNumber = "";
    //   // this.truckPrefix = "";
    //   this.error = "";
    //   this.$refs.form.resetValidation();
    // },
    haserror() {
      return this.error !== null;
    },

    changeMilestone(item) {
      console.log(this.driverPrice, this.assignmentDetails);

      this.loading = true;
      const data = {
        assignmentId: this.assignmentDetails._id.toString(),
      };
      if (this.milestone && this.milestone.length > 0) {
        data.milestoneId = this.milestone;
      }
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const { apiUrl } = this.constants;
      this.axios
        .post(`${apiUrl}/assignments/change-milestone`, data, config)
        .then(
          (response) => {
            this.dialog = false;
            this.dialogFinalConfirmation = false;
            const { data } = response.data;
            this.milestone = null;
            this.$eventBus.$emit("refresh-job");
            this.loading = false;
          },
          (error) => {
            console.log(error.data);
            this.error = error.data.message;
            this.dialogFinalConfirmation = false;
            this.dailog = false;
            this.loading = false;
          }
        );
    },
  },
};
</script>
<style scoped>
.milestone-current-tag {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 999px;
  color: #c35f02;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1;
  margin-left: 0.5rem;
  padding: 0.2rem 0.5rem;
}

.reset-pos {
  position: relative;
  top: 9px;
}

.break_long_text {
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
.user {
  padding: 10px;
}
.comments-view .v-toolbar {
  width: 100%;
  /* margin-left: 25%; */
}
.v-toolbar--fixed {
  position: inherit;
}
.view-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #c87ffe;
  border: 2px solid indigo;
  padding: 2px 5px;
  border-radius: 5px;
}
.assignment {
  text-align: center;
  font-weight: bolder;
  font-size: large;
}
.ccc.theme--light.v-input:not(.v-input--is-disabled) input,
.theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: rgba(0, 0, 0, 0.54);
}

.log {
  display: inline-flex;
  flex: 0 0 auto;
  margin: 0;
}

.milestone-action-btn {
  align-items: center !important;
  background: var(--oms-primary, #ea7a1c) !important;
  border: 0.0625rem solid var(--oms-primary, #ea7a1c) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  box-shadow: 0 0.125rem 0.5rem rgba(234, 122, 28, 0.24) !important;
  color: #ffffff !important;
  display: inline-flex !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  height: var(--oms-control-height, 2.375rem) !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  min-height: var(--oms-control-height, 2.375rem) !important;
  min-width: 0 !important;
  padding: 0 0.75rem !important;
  text-transform: none !important;
  white-space: nowrap !important;
}

.milestone-action-btn:hover,
.milestone-action-btn:focus {
  background: var(--oms-primary-dark, #d96a10) !important;
  border-color: var(--oms-primary-dark, #d96a10) !important;
  box-shadow: 0 0.1875rem 0.625rem rgba(234, 122, 28, 0.3) !important;
}

.milestone-action-btn.v-btn--disabled,
.milestone-action-btn[disabled] {
  background: var(--oms-disabled-bg, #eef2f7) !important;
  border-color: var(--oms-disabled-border, #d9e0ea) !important;
  box-shadow: none !important;
  color: var(--oms-disabled-ink, #98a2b3) !important;
}
</style>
<style lang="scss">
/* Change Milestone + Final Confirmation dialogs (rendered at the app root). */
.application .v-dialog.milestone-dialog {
  max-width: calc(100vw - 2rem) !important;
  width: min(34rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.milestone-confirm-dialog {
  max-width: calc(100vw - 2rem) !important;
  width: min(26rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.milestone-dialog .cm-card,
.application .v-dialog.milestone-confirm-dialog .cm-card {
  border-radius: 1rem !important;
  overflow: hidden;
}

.application .v-dialog.milestone-dialog .cm-head,
.application .v-dialog.milestone-confirm-dialog .cm-head {
  align-items: center;
  background: var(--oms-peach, #fff7ed);
  border-bottom: 0.0625rem solid var(--oms-peach-border, #fed7aa);
  display: flex;
  gap: 0.75rem;
  padding: 1rem 0.75rem 1rem 1.25rem;
}

.application .v-dialog.milestone-dialog .cm-head__icon,
.application .v-dialog.milestone-confirm-dialog .cm-head__icon {
  align-items: center;
  background: var(--oms-primary, #ea7a1c);
  border-radius: 0.75rem;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;
}

.application .v-dialog.milestone-dialog .cm-head__icon .v-icon,
.application .v-dialog.milestone-confirm-dialog .cm-head__icon .v-icon {
  color: #ffffff !important;
  font-size: 1.25rem !important;
}

.application .v-dialog.milestone-dialog .cm-head__text,
.application .v-dialog.milestone-confirm-dialog .cm-head__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.application .v-dialog.milestone-dialog .cm-head__text strong,
.application .v-dialog.milestone-confirm-dialog .cm-head__text strong {
  color: var(--oms-navy, #1c2b5f);
  font-size: 1rem;
  font-weight: 800;
}

.application .v-dialog.milestone-dialog .cm-head__text span,
.application .v-dialog.milestone-confirm-dialog .cm-head__text span {
  color: var(--oms-muted, #74716a);
  font-size: 0.8125rem;
  line-height: 1.4;
}

.application .v-dialog.milestone-dialog .cm-head__close.v-btn,
.application .v-dialog.milestone-confirm-dialog .cm-head__close.v-btn {
  align-self: flex-start;
  margin: -0.25rem 0 0 !important;
}

.application .v-dialog.milestone-dialog .cm-head__close .v-icon,
.application .v-dialog.milestone-confirm-dialog .cm-head__close .v-icon {
  color: var(--oms-muted, #74716a) !important;
}

.application .v-dialog.milestone-dialog .cm-progress {
  margin: 0 !important;
}

.application .v-dialog.milestone-dialog .cm-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: min(60vh, 28rem);
  overflow-y: auto;
  padding: 1.125rem 1.25rem 1.25rem;
}

.application .v-dialog.milestone-dialog .cm-label {
  color: var(--oms-muted, #74716a);
  display: block;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 0.375rem;
  text-transform: uppercase;
}

.application .v-dialog.milestone-dialog .cm-current {
  background: var(--oms-surface-soft, #faf9f6);
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.75rem;
  padding: 0.75rem 0.875rem;
}

.application .v-dialog.milestone-dialog .cm-route {
  align-items: center;
  color: var(--oms-ink-strong, #1a1916);
  display: flex;
  flex-wrap: wrap;
  font-size: 0.9375rem;
  font-weight: 700;
  gap: 0.375rem;
  text-transform: capitalize;
}

.application .v-dialog.milestone-dialog .cm-route .v-icon {
  color: var(--oms-primary, #ea7a1c) !important;
  font-size: 1rem !important;
}

.application .v-dialog.milestone-dialog .cm-route .cm-route__arrow {
  color: var(--oms-muted, #74716a) !important;
}

.application .v-dialog.milestone-dialog .cm-select-row {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.application .v-dialog.milestone-dialog .cm-select.v-input {
  flex: 1 1 auto;
  font-size: 0.875rem !important;
  margin: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.milestone-dialog .cm-select .v-input__slot {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  margin: 0 !important;
  min-height: 2.75rem !important;
  padding: 0 0.75rem !important;
}

.application .v-dialog.milestone-dialog .cm-select .v-input__slot::before,
.application .v-dialog.milestone-dialog .cm-select .v-input__slot::after {
  display: none !important;
}

.application .v-dialog.milestone-dialog .cm-select.v-input--is-focused .v-input__slot,
.application .v-dialog.milestone-dialog .cm-select.v-select--is-menu-active .v-input__slot {
  border-color: var(--oms-primary, #ea7a1c) !important;
}

.application .v-dialog.milestone-dialog .cm-select .v-select__selection,
.application .v-dialog.milestone-dialog .cm-select input {
  color: var(--oms-ink-strong, #1a1916) !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  -webkit-text-fill-color: var(--oms-ink-strong, #1a1916) !important;
}

.application .v-dialog.milestone-dialog .cm-select .v-label {
  color: var(--oms-muted, #74716a) !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  -webkit-text-fill-color: var(--oms-muted, #74716a) !important;
}

.application .v-dialog.milestone-dialog .cm-clear.v-btn {
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  flex: 0 0 auto;
  height: 2.75rem !important;
  margin: 0 !important;
  width: 2.75rem !important;
}

.application .v-dialog.milestone-dialog .cm-clear .v-icon {
  color: var(--oms-muted, #74716a) !important;
  font-size: 1.125rem !important;
}

.application .v-dialog.milestone-dialog .cm-clear.v-btn:hover {
  background: var(--oms-red-soft, #fbeae8) !important;
  border-color: var(--oms-red-border, #f0cfcc) !important;
}

.application .v-dialog.milestone-dialog .cm-clear.v-btn:hover .v-icon {
  color: var(--oms-red, #be3b32) !important;
}

/* Checkpoints of the selected milestone: numbered steps that wrap. */
.application .v-dialog.milestone-dialog .cm-steps {
  counter-reset: none;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.application .v-dialog.milestone-dialog .cm-steps li {
  align-items: center;
  background: var(--oms-surface, #ffffff);
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 999rem;
  display: inline-flex;
  gap: 0.4375rem;
  padding: 0.25rem 0.75rem 0.25rem 0.25rem;
}

.application .v-dialog.milestone-dialog .cm-steps__index {
  align-items: center;
  background: var(--oms-primary, #ea7a1c);
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 800;
  height: 1.375rem;
  justify-content: center;
  width: 1.375rem;
}

.application .v-dialog.milestone-dialog .cm-steps__name {
  color: var(--oms-ink, #3a382f);
  font-size: 0.8125rem;
  font-weight: 600;
}

.application .v-dialog.milestone-dialog .cm-error {
  align-items: flex-start;
  background: var(--oms-red-soft, #fbeae8);
  border: 0.0625rem solid var(--oms-red-border, #f0cfcc);
  border-radius: 0.625rem;
  color: var(--oms-red, #be3b32);
  display: flex;
  font-size: 0.8125rem;
  font-weight: 600;
  gap: 0.5rem;
  padding: 0.625rem 0.75rem;
}

.application .v-dialog.milestone-dialog .cm-error .v-icon {
  color: inherit !important;
  margin-top: 0.0625rem;
}

.application .v-dialog.milestone-dialog .cm-actions,
.application .v-dialog.milestone-confirm-dialog .cm-actions {
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
  display: flex;
  gap: 0.625rem;
  justify-content: flex-end;
  padding: 0.875rem 1.25rem;
}

.application .v-dialog.milestone-dialog .cm-btn.v-btn,
.application .v-dialog.milestone-confirm-dialog .cm-btn.v-btn {
  border-radius: 0.625rem !important;
  font-size: 0.8125rem !important;
  font-weight: 800 !important;
  height: 2.5rem !important;
  margin: 0 !important;
  min-width: 6rem !important;
  text-transform: none !important;
}

.application .v-dialog.milestone-dialog .cm-btn--ghost.v-btn,
.application .v-dialog.milestone-confirm-dialog .cm-btn--ghost.v-btn {
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  color: var(--oms-ink, #3a382f) !important;
}

.application .v-dialog.milestone-dialog .cm-btn--primary.v-btn,
.application .v-dialog.milestone-confirm-dialog .cm-btn--primary.v-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.application .v-dialog.milestone-dialog .cm-btn--primary.v-btn .v-btn__content,
.application .v-dialog.milestone-confirm-dialog .cm-btn--primary.v-btn .v-btn__content {
  color: #ffffff !important;
}

.application .v-dialog.milestone-dialog .cm-btn.v-btn--disabled,
.application .v-dialog.milestone-confirm-dialog .cm-btn.v-btn--disabled {
  opacity: 0.55;
}
</style>
